// extracted by mini-css-extract-plugin
module.exports = {"PasswordResetEmail":"zf_a bhu_px bhu_a bhu_w bhu_cw bhu_sb","PasswordResetEmail__title":"zf_b bhu_uj bhu_qk bhu_tu","PasswordResetEmail__subtitle":"zf_c bhu_tu"};